import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'flowbite';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { NavigationProvider } from './context/NavigationContext';
import { AuthProvider } from './context/AuthContext';
import { registerServiceWorker } from './registerServiceWorker';

const isDevelopment = process.env.NODE_ENV === 'development';

// Register service worker for production environment
if (!isDevelopment) {
  registerServiceWorker();
}

ReactDOM.createRoot(document.getElementById('root')).render(
  isDevelopment ? (
      <AuthProvider>
        <Router>
        <NavigationProvider>
            <App />
        </NavigationProvider>
      </Router>
    </AuthProvider>
  ) : (
    <AuthProvider>
      <Router>
        <NavigationProvider>
          <App />
        </NavigationProvider>
      </Router>
    </AuthProvider>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
